type SubjectsProps = { material: Material };

const Subjects = (props: SubjectsProps) => {
    const { material } = props;

    const { materialTopCategories } = material;

    const categoriesAreEmpty = !materialTopCategories || materialTopCategories.length < 1;

    if (categoriesAreEmpty) {
        return <></>;
    }

    return (
        <div className='m-subjects tsc-body'>
            <span>{materialTopCategories.map(({ title }) => title).join(', ')}</span>
        </div>
    );
};

export default Subjects;
